import { instance } from '@/libs/api/instance'

export const terminateSession = async (id) => {
  return instance.delete(`/v3/auth/${id}`)
}
